if (!customElements.get('hello-featured-variant-gallery')) {
  customElements.define(
    'hello-featured-variant-gallery',
    class HelloFeaturedVariantGallery extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mediaGallery = this.querySelector('media-gallery');
        this.viewer = this.querySelector('[id^="GalleryViewer"]');

        this.bindMainArrows();
        this.updateArrowState();

        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data?.sectionId) !== String(this.sectionId)) return;
          this.applyVariant(event.data?.variant);
        });
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
      }

      bindMainArrows() {
        const prev = this.viewer?.querySelector('[data-hello-gallery-nav="previous"]');
        const next = this.viewer?.querySelector('[data-hello-gallery-nav="next"]');

        prev?.addEventListener('click', (event) => {
          event.preventDefault();
          this.stepMainSlide(-1);
        });

        next?.addEventListener('click', (event) => {
          event.preventDefault();
          this.stepMainSlide(1);
        });
      }

      getVisibleMainSlides() {
        return [...this.querySelectorAll('.hello-variant-slide')].filter(
          (slide) => !slide.classList.contains('hello-variant-slide--hidden') && !slide.hidden
        );
      }

      getActiveSlideIndex(slides) {
        const index = slides.findIndex((slide) => slide.classList.contains('is-active'));
        return index >= 0 ? index : 0;
      }

      stepMainSlide(direction) {
        const slides = this.getVisibleMainSlides();
        if (slides.length < 2) return;

        const currentIndex = this.getActiveSlideIndex(slides);
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= slides.length) return;

        const mediaId = slides[nextIndex].dataset.mediaId;
        if (!mediaId) return;

        this.mediaGallery?.setActiveMedia?.(mediaId, false);
        this.updateArrowState();
      }

      updateArrowState() {
        const slides = this.getVisibleMainSlides();
        const prev = this.viewer?.querySelector('[data-hello-gallery-nav="previous"]');
        const next = this.viewer?.querySelector('[data-hello-gallery-nav="next"]');

        if (!prev || !next) return;

        if (slides.length < 2) {
          prev.setAttribute('disabled', 'disabled');
          next.setAttribute('disabled', 'disabled');
          return;
        }

        const currentIndex = this.getActiveSlideIndex(slides);

        if (currentIndex <= 0) prev.setAttribute('disabled', 'disabled');
        else prev.removeAttribute('disabled');

        if (currentIndex >= slides.length - 1) next.setAttribute('disabled', 'disabled');
        else next.removeAttribute('disabled');
      }

      applyVariant(variant) {
        const activeKey = this.resolveVariantKey(variant);
        if (!activeKey) return;

        this.dataset.activeKey = activeKey;

        const isVisible = (el) =>
          el.dataset.helloShared === 'true' || el.dataset.helloVariantKey === activeKey;

        let firstVisibleId = null;

        this.querySelectorAll('.hello-variant-slide').forEach((slide) => {
          const show = isVisible(slide);
          slide.toggleAttribute('hidden', !show);
          slide.classList.toggle('hello-variant-slide--hidden', !show);
          slide.classList.remove('is-active');
          if (show && !firstVisibleId) firstVisibleId = slide.dataset.mediaId;
        });

        this.querySelectorAll('.hello-variant-thumb').forEach((thumb) => {
          const show = isVisible(thumb);
          thumb.toggleAttribute('hidden', !show);
          thumb.classList.toggle('hello-variant-slide--hidden', !show);
          thumb.querySelector('button')?.removeAttribute('aria-current');
        });

        if (firstVisibleId) {
          this.mediaGallery?.setActiveMedia?.(firstVisibleId, true);
        }

        const thumbSlider = this.querySelector(`#GalleryThumbnails-${this.sectionId}`);
        thumbSlider?.resetPages?.();

        this.updateArrowState();
      }

      resolveVariantKey(variant) {
        if (!variant?.options?.length) return this.dataset.activeKey;

        const variantKeys = [
          ...new Set(
            [...this.querySelectorAll('[data-hello-variant-key]')].map((el) => el.dataset.helloVariantKey)
          ),
        ].filter(Boolean);

        for (const option of variant.options) {
          const key = this.handleize(option);
          if (variantKeys.includes(key)) return key;
        }

        return variantKeys[0] || this.dataset.activeKey;
      }

      handleize(value) {
        return String(value)
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
    }
  );
}
